/**
 * apiClient.js
 * ---------------------------------------------------------------------------
 * Thin fetch wrapper around the CaseSignalHQ API. In development, Vite
 * proxies /api/* to http://localhost:4000 (see vite.config.js).
 *
 * Every method returns { ok, ...data } mirroring the server's response
 * envelope so UI code can branch on `ok` uniformly.
 */

const BASE = "/api";

async function post(path, payload) {
  try {
    const res = await fetch(`${BASE}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    return data;
  } catch (err) {
    return {
      ok: false,
      error: "Network error. Please try again.",
      detail: err.message,
    };
  }
}

export const api = {
  submitCase: (payload) => post("/case-intake", payload),
  submitFirmInquiry: (payload) => post("/firm-inquiry", payload),
  submitCoConsoleXInquiry: (payload) => post("/coconsolex-inquiry", payload),
};
